<div class="dane-obiektu" *ngIf="tagiArr.length>0">
  <div class="flex flex-row flex-wrap gap-1 tagi">
    <mat-chip-set role="list" *ngFor="let stag of tagiToDisplay$ | async" disableRipple="true" selectable="false">
      <mat-chip role="listitem" style="cursor:pointer!important;" disableRipple="true" selectable="false"
        (click)="wyszukajPoTagu(stag);"> {{stag.tag | wyborTlumaczenia:aktualnyJezyk}}
      </mat-chip>
    </mat-chip-set>
  </div>
</div>
